module.exports = __webpack_public_path__ + "img/price-tag.9fc9a8ba.svg";